module.exports = __webpack_public_path__ + "static/img/a040.52e2736.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a040.jpg
// module id = 9DdM
// module chunks = 0